/** Coluna virtual para clientes sem id_grupo (legado / não classificados). */
export const AWARENESS_UNSET_GROUP_STAGE_ID = 0;
